/*global google*/
import React, { Component } from "react";
import { Map, InfoWindow, Marker, GoogleApiWrapper } from "google-maps-react";

export class MapContainer extends Component {
    constructor(props) {
        super(props);
        this.onMarkerClick = this.onMarkerClick.bind(this);
        this.state = {
            showingInfoWindow: false,
            activeMarker: {},
            selectedPlace: {}
        };
    }
    onMarkerClick(props, marker, e) {
        this.setState({
            selectedPlace: props,
            activeMarker: marker,
            showingInfoWindow: true
        });
    }
    render() {
        if (!this.props.google) {
            return <div>Loading...</div>;
        }

        return (
            <div
                style={{
                    position: "relative",
                    height: "40vh"
                }}
            >
                <Map style={{ filter: 'grayscale(100%)' }}
                    google={this.props.google}
                    zoom={16}
                    initialCenter={{
                        lat: 50.81891546151131,
                        lng: 19.13048681208421,
                    }}>

                    <Marker
                        onClick={this.onMarkerClick}
                        name={"ICON Beauty"}
                    /*
                    icon={{
                        url: "/img/icon.svg",
                        anchor: new google.maps.Point(32, 32),
                        scaledSize: new google.maps.Size(64, 64)
                    }}
                    */
                    />
                    <InfoWindow
                        marker={this.state.activeMarker}
                        visible={this.state.showingInfoWindow}
                    >
                        <div>
                            <h5>{this.state.selectedPlace.name}</h5>
                        </div>
                    </InfoWindow>
                </Map>
            </div>
        );
    }
}
export default GoogleApiWrapper({
    apiKey: "AIzaSyB8w3Lz8w7B9IL7lxvtMtbILrNNcfGPLGg",
    v: "3.30"
})(MapContainer);
